import React, { useState, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Col, Row, Button, Form, Label, Input } from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";

function ClientesCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS       = process.env.REACT_APP_URL_LOGS;
  const URL_CLIENTES   = process.env.REACT_APP_URL_CLIENTES;
  const URL_SUCURSALES = process.env.REACT_APP_URL_SUCURSALES;

  const [nombre_comercial, setNombreComercial] = useState("");
  const [razon_social, setRazonSocial]         = useState("");
  const [codigo, setCodigo]                     = useState("");
  const [observaciones, setObservaciones]       = useState("NA");
  const [validaBoton, setValidaBoton]           = useState(true);

  const handleNombreChange = (e) => {
    const val = e.target.value;
    setNombreComercial(val);
    if (!codigo || codigo === nombre_comercial) setCodigo(val);
  };

  const saveClientes = async (event) => {
    event.preventDefault();
    setValidaBoton(false);
    const auth = { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } };
    try {
      const response = await axios.post(URL_CLIENTES, {
        nombre_comercial,
        razon_social: razon_social || nombre_comercial,
        codigo: codigo || nombre_comercial,
        RFC: "NA",
        calle: "NA", numero_ext: "NA", numero_int: "NA",
        delegacion: "NA", estado: "NA", pais: "Mexico",
        cp: "NA", colonia: "NA", ciudad: "NA",
        telefono: "NA", email: "NA",
        observaciones,
        ultimo_pago: "2000-01-01",
        forma_pago: "Contado",
        calificadora: 1,
        cargos: 0, abonos: 0, saldo: 0,
        regFiscal: 0, plazo: 0,
        alertasVentas: "No", alertasEdoCta: "No", alertasMarketing: "No",
        listaPrecios: 1,
      }, auth);
      const idPost = response.data._id;
      await axios.post(URL_SUCURSALES, {
        calle: "NA", numero_ext: "NA", numero_int: "NA", delegacion: "NA",
        estado: "NA", pais: "Mexico", cp: "NA", colonia: "NA", ciudad: "NA",
        clientes: idPost, alias: "Principal", RFC: "NA",
        razon_social: razon_social || nombre_comercial,
        is_active: "Si", regFiscal: 0,
      }, auth);
      await axios.post(URL_LOGS, { tipo: "Crear Cliente", detalle: nombre_comercial, user: user.id }, auth);
      Swal.fire("Good job!", "Creado con exito", "success");
      setTimeout(() => window.location.reload(), 1000);
    } catch (error) {
      Swal.fire({ icon: "error", title: "Oops...", text: "Something went wrong!", footer: `${error?.response?.data?.message || ""}` });
      console.log(error);
      setValidaBoton(true);
    }
  };

  const sec   = { borderLeft: "4px solid #3b82f6", paddingLeft: 12, marginBottom: 8, color: "#1e3a8a", fontWeight: 600, fontSize: "0.85rem", textTransform: "uppercase", letterSpacing: "0.05em" };
  const block = { background: "#f8fafc", borderRadius: 8, padding: "14px 16px", marginBottom: 16 };

  return (
    <>
      <Header />
      <br /><br />
      {user.clientes_create ? (
        <div className="card container">
          <h3 align="center">Nuevo Cliente</h3>
          <Form onSubmit={saveClientes}>
            <div style={block}>
              <div style={sec}>🏢 Identificación</div>
              <Row>
                <Col md={4}>
                  <Label>Nombre Comercial</Label>
                  <Input type="text" placeholder="Nombre Comercial" value={nombre_comercial} required onChange={handleNombreChange} />
                </Col>
                <Col md={4}>
                  <Label>Razón Social</Label>
                  <Input type="text" placeholder="Razón Social" value={razon_social} onChange={(e) => setRazonSocial(e.target.value)} />
                </Col>
                <Col md={4}>
                  <Label>Código</Label>
                  <Input type="text" placeholder="Código" value={codigo} onChange={(e) => setCodigo(e.target.value)} />
                </Col>
              </Row>
              <Row className="mt-2">
                <Col md={6}>
                  <Label>Observaciones</Label>
                  <Input type="text" placeholder="Observaciones" value={observaciones} onChange={(e) => setObservaciones(e.target.value)} />
                </Col>
              </Row>
            </div>
            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">Guardar</Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>Guardar</Button>
            )}
            <Button href="/Clientes" className="btn btn-danger" id="botonListado">Regresar</Button>
          </Form>
          <br />
        </div>
      ) : undefined}
    </>
  );
}

export default ClientesCreate;
